import { FiltersDisplayedEvent } from '@/events/FiltersDisplayedEvent';
import { EventAggregationService } from '@/platform/EventAggregationService';
import { IEventAggregationService, ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { computed, ref, Ref } from 'vue';


export class TagContainer implements ISubscriber<FiltersDisplayedEvent> {

	public tagContainerRef: Ref<HTMLElement | null> = ref(null);
	public isTagContainerMoreThanTwoRows = ref(false);
	public isCollapsed = ref(true);

	private readonly eventAggregationService: IEventAggregationService;
	private observer: MutationObserver;
	private tagContainerMaxHeight = 0;
	private disposed = false;

	public constructor(eventAggregationService?: IEventAggregationService) {
		this.eventAggregationService = eventAggregationService ?? EventAggregationService.instance;
		this.eventAggregationService.subscribeTo(FiltersDisplayedEvent.EventType, this, true);
	}

	public dispose(): void {
		this.disposed = true;
	}

	public notify(event: FiltersDisplayedEvent): void {
		if (FiltersDisplayedEvent.is(event) && !this.disposed) {
			this.setIsTagContainerMoreThanTwoRows();
		}
	}

	public onMounted(): void {
		this.tagContainerMaxHeight = this.getTagContainerMaxHeight();
		this.setIsTagContainerMoreThanTwoRows();
		this.initTagContainerObserver();
	}

	public onUnmounted(): void {
		this.observer?.disconnect();
	}

	public shouldDisplayShowMore = computed(() => {
		return this.isCollapsed.value && this.isTagContainerMoreThanTwoRows.value;
	})

	public shouldDisplayShowLess = computed(() => {
		return !this.isCollapsed.value && this.isTagContainerMoreThanTwoRows.value;
	})

	public showMore = (): void => {
		this.isCollapsed.value = false;
		this.tagContainerRef.value?.classList.remove("Collapsed");
	}

	public showLess = (): void => {
		this.isCollapsed.value = true;
		this.tagContainerRef.value?.classList.add("Collapsed");
	}

	private setIsTagContainerMoreThanTwoRows = (): void => {
		const container = this.tagContainerRef.value;
		if (!container) {
			return;
		}
		this.isTagContainerMoreThanTwoRows.value = this.tagContainerMaxHeight < container.scrollHeight;
	}

	private getTagContainerMaxHeight(): number {
		if (!this.tagContainerRef || !this.tagContainerRef.value) {
			return 0;
		}
		const style = window.getComputedStyle(this.tagContainerRef.value);
		const values = style.maxHeight.match(/\d+/g);
		return values ? +values[0] : 0;
	}

	private initTagContainerObserver(): void {
		const observer = new MutationObserver(this.setIsTagContainerMoreThanTwoRows);

		observer.observe(this.tagContainerRef.value as Node, {
			subtree: false,
			childList: true
		})
		this.observer = observer;
	}
}
